import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Firestore, collectionData, limit } from '@angular/fire/firestore';
import { collection, doc, getDocs, query, setDoc, where } from 'firebase/firestore';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class MyLibraryService {
	httpUrl = environment.url;
	categories: any;

	constructor(
		private httpClient: HttpClient,
		private firestore: Firestore
	) { }

	async ngOnInit() {}

	getPrograms() {
		// const programsRef = query(collection(this.firestore, 'programs'));
		// Fetches programs from publishedPrograms collection instead of programs collection
		const programsRef = query(collection(this.firestore, 'publishedPrograms'));
		return collectionData(programsRef, { idField: 'id' }) as Observable<any>;
	}

	getCategories() {
		const categoriesRef = collection(this.firestore, `categories`);
		return collectionData(categoriesRef, { idField: 'id' }) as Observable<any>;
	}

	async getCurrentPrograms(categoryId: any, subcategName: any) {
		// const programsRef = collection(this.firestore, 'programs');
		// Fetches programs from publishedPrograms collection instead of programs collection
		const programsRef = collection(this.firestore, 'publishedPrograms');
		let querySnapshot;
		if (subcategName === "All") {
			querySnapshot = await getDocs(query(programsRef, where('category.id', '==', categoryId)));
		} else {
			querySnapshot = await getDocs(query(programsRef, where('category.id', '==', categoryId), where('subCategory.name', '==', subcategName)));
		}

		const currentPrograms: any = [];
		querySnapshot.forEach((doc) => {
			currentPrograms.push(doc.data());
		});

		return currentPrograms;
	}

	async getCategoryByName(categoryName: any) {
		const categoriesRef = collection(this.firestore, 'categories');
		const querySnapshot = await getDocs(query(categoriesRef, where('name', '==', categoryName)));
		let categoryData: any;
		querySnapshot.forEach((doc) => {
			//   console.log('doc.data()', doc.data())
			categoryData = doc.data()
		});

		return categoryData;
	}

	async getFirstCurrentTabProgram(categId: any, subcategId: any) {
		// const programsRef: any = collection(this.firestore, 'programs');
		// Fetches programs from publishedPrograms collection instead of programs collection
		const programsRef = collection(this.firestore, 'publishedPrograms');

		const currentPrograms: any = [];
		if(categId && subcategId) {
			const querySnapshot: any = await getDocs(query(programsRef, where('category.id', '==', categId), where('subCategory.id', '==', subcategId)));
			querySnapshot.forEach((doc: any) => {
				currentPrograms.push(doc.data());
			});
		//   console.log('currentPrograms', currentPrograms)
		}

		if(categId && !subcategId){
			const querySnapshot: any = await getDocs(query(programsRef, where('category.id', '==', categId)));
			querySnapshot.forEach((doc: any) => {
				currentPrograms.push(doc.data());
			});
			// console.log('currentPrograms', currentPrograms)
		}

		return currentPrograms;
	}

	async addRegisterInterestForProgram(data: any, id:string) {
		// console.log(id);
		// console.log(data);
		let collectionRef = 'registerInterest';
		try{
		  if(!id) {
			id = doc(collection(this.firestore, collectionRef)).id;
		  }
		  collectionRef = `registerInterest/${id}`;
		  const categoriesRef = doc(this.firestore, collectionRef);
		  await setDoc(categoriesRef, data);
		//   return 'success';
		}catch(err) {
		  return err
		}
	  }

	  getRegisterInterest() {
		const interestRef = collection(this.firestore, 'registerInterest');
		return collectionData(interestRef, { idField: 'id' }) as Observable<any>;
	}
}
